export default __webpack_public_path__ + "static/media/mobile_review_map.f2ac2029.png";